import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  centralBankPaymentList: {
    status: StateStatus | null;
    data: any;
  };
  updateCentralBankPaymentStatus: StateStatus | null | undefined;
  centralBankPaymentStatusCodesList: {
    status: StateStatus | null;
    data: any;
  };
  centralBankPaymentAccountsList: {
    status: StateStatus | null;
    data: any;
  };
  fetchCentralBankPayments: StateStatus | null | undefined;
  matchCentralBankPayments: StateStatus | null | undefined;
}

const initialState: IState = {
  centralBankPaymentList: {
    status: null,
    data: null,
  },
  updateCentralBankPaymentStatus: null,
  centralBankPaymentStatusCodesList: {
    status: null,
    data: null,
  },
  centralBankPaymentAccountsList: {
    status: null,
    data: null,
  },
  fetchCentralBankPayments: null,
  matchCentralBankPayments: null,
};

const CentralBankPaymentListReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_CENTRAL_BANK_PAYMENT_LIST:
      return {
        ...state,
        centralBankPaymentList: {
          ...state.centralBankPaymentList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.centralBankPaymentList.data
              : action.data,
        },
      };
    case Types.SET_CENTRAL_BANK_PAYMENT_ACCOUNTS_LIST:
      return {
        ...state,
        centralBankPaymentAccountsList: {
          ...state.centralBankPaymentAccountsList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.centralBankPaymentAccountsList.data
              : action.data,
        },
      };
    case Types.SET_CENTRAL_BANK_PAYMENT_STATUS_CODES_LIST:
      return {
        ...state,
        centralBankPaymentStatusCodesList: {
          ...state.centralBankPaymentStatusCodesList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.centralBankPaymentStatusCodesList.data
              : action.data,
        },
      };
    case Types.UPDATE_CENTRAL_BANK_PAYMENT_STATUS:
      return {
        ...state,
        updateCentralBankPaymentStatus: action.status,
      };
    case Types.FETCH_CENTRAL_BANK_PAYMENTS:
      return {
        ...state,
        fetchCentralBankPayments: action.status,
      };
    case Types.MATCH_CENTRAL_BANK_PAYMENTS:
      return {
        ...state,
        matchCentralBankPayments: action.status,
      };
    default:
      return {
        ...state,
      };
  }
};

export default CentralBankPaymentListReducer;
